import { render, staticRenderFns } from "./ProductCategoryTabs.vue?vue&type=template&id=0a259a70&scoped=true&"
import script from "./ProductCategoryTabs.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryTabs.vue?vue&type=script&lang=js&"
import style0 from "../../styles/product-category-tabs.css?vue&type=style&index=0&id=0a259a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a259a70",
  null
  
)

export default component.exports